import styled from 'styled-components';

import Img from 'gatsby-image';

export const BannerContainer = styled.div`
  /* display: flex; */
  position: relative;
  justify-content: center;
  align-items: center;
  padding: relative;
  /* width: 100%; */
  /* height: 20px; */
  margin-right: 20px;
  /* margin-top: 5rem; */
`;
export const BannerBg = styled.div`
  overflow: hidden;
  display: grid;
  grid-template-columns: 1fr 1fr;
  padding-top: 4rem;
  @media screen and (max-width: 600px) {
    grid-template-columns: 1fr;
  }
  @media screen and (max-width: 368px) {
    display: block;
  }
  /* padding-left: 0.1rem; */
`;
export const BannerIntro = styled.div`
  display: flex;
  justify-content: center;
  text-align: center;
  align-items: center;
  padding: 5px;
  color: #ff7f00;
  @media screen and (max-width: 300px) {
    display: block;
    min-height: 200px;
  }
`;

export const BannerImage = styled(Img)`
  /* border-radius: 10px; */
  height: 100%;
  filter: brightness(80%);
  transition: 0.6s cubic-bezier(0.075, 0.82, 0.165, 1);
`;
export const BannerHeading = styled.div`
  color: #0c0c0c;
  font-size: 14px;
  text-align: center;
`;
export const Heading = styled.div`
  font-family: 'Roboto Mono', monospace;
  color: #5e0087;
  overflow: hidden;
  letter-spacing: 2px;
  font-size: 24px;
  font-weight: 400;
  min-height: 30px;
  max-height: 30px;
  margin-left: 10rem;
  margin-right: 10rem;
  @media screen and (max-width: 786px) {
    margin-left: 5rem;
    margin-right: 5rem;
    min-height: 30px;
    max-height: 70px;
  }
  @media screen and (max-width: 300px) {
    display: block;
    margin: 0;
    font-size: 18px;
  }
  /* width: 60%; */
`;
export const BannerSubtitle = styled.div`
  animation-delay: 2s;
  padding: 10px;
  margin-right: 20px;
  justify-content: center;
  align-items: center;
  top: 30px;
  color: #ff7f00;
  font-size: 16px;
  overflow: hidden;
  letter-spacing: 2px;
  display: flex;
  white-space: pre-line;
  @media screen and (max-width: 300px) {
    display: block;
    margin: 0;
    font-size: 10px;
  }
`;
export const CodeSpace = styled.p`
  letter-spacing: 2px;
  height: auto;
  white-space: pre-line;
  margin-left: 5px;
  margin-right: 5px;
  color: #0c0c0c;
  font-size: 20px;
`;
